import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  otpInput: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    direction: 'ltr',
    backgroundColor: theme.colors.background.normal,
  },

  wrap: {
    position: 'relative',
    display: 'flex',
    marginLeft: '8px',
  },

  input: {
    borderRadius: '0',
    border: 'none',
    color: theme.colors.background.text,
    height: `${theme.sizes.base * 6}px`,
    position: 'absolute',
    fontSize: '20px',
    textAlign: 'center',
    backgroundColor: 'transparent',
    outline: 'none',
    fontWeight: 'bold',
    zIndex: 1,
    '&.invalid': {
      color: theme.colors.danger.normal,
    },
    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
      '-webkit-box-shadow': '0 0 0 100px white inset',
      backgroundColor: '#fff !important',
      backgroundClip: 'content-box !important',
    },
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      appearance: 'none',
      margin: 0,
    },
  },
  display: {
    width: '32px',
    height: '48px',
    marginRight: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: 'bold',
    position: 'relative',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: theme.colors.background.border,
    color: theme.colors.background.text,
    '&:last-child': {
      borderRight: 'none',
    },
    '&.fill': {
      borderBottomColor: theme.colors.background.text,
    },
    '&.fill.invalid': {
      borderBottomColor: theme.colors.danger.normal,
      color: theme.colors.danger.normal,
    },
    '&.focused': {
      borderBottomColor: theme.colors.background.text,
    },
  },
}));

export default useStyle;
